import { z } from 'zod'

const ItemSchema = z.object({
  id: z.number(),
  seq: z.number(),
  item: z.object({
    itemId: z.number(),
    lotNo: z.string(),
    lotDate: z.coerce.date(),
    mold: z.string(),
    isClaimItem: z.boolean(),
    unit: z.string(),
  }),
  qty: z.number(),
  location: z.string(),
})

export const Inv3020GetResultSchema = z.object({
  number: z.string(),
  date: z.string(),
  refNo: z.string().nullish(),
  refDate: z.string().nullish(),
  remark: z.string().nullish(),
  items: z.array(ItemSchema),
  status: z.number(),
  inventoryStatus: z.number().nullish(),
})

export type Inv3020GetResultModel = z.input<typeof Inv3020GetResultSchema>
